import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BoAuthInputComponent } from '../bo-auth-input/bo-auth-input.component';

@Component({
  selector: 'lib-bo-auth-password-input',
  standalone: true,
  imports: [CommonModule, BoAuthInputComponent],
  templateUrl: './bo-auth-password-input.component.html',
  styleUrls: ['./bo-auth-password-input.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoAuthPasswordInputComponent {
  readonly inputId = input.required<string>();
  readonly label = input.required<string>();
  readonly placeholder = input('');
  readonly autocomplete = input('new-password');
  readonly control = input.required<FormControl>();
  readonly customErrorMessage = input('Campo invalido');

  readonly showPassword = signal(false);

  readonly inputType = signal<'password' | 'text'>('password');

  togglePassword(): void {
    const next = !this.showPassword();
    this.showPassword.set(next);
    this.inputType.set(next ? 'text' : 'password');
  }
}
